import { Service } from "./Service.js";

export class HistoryService extends Service {
  pushState(data, url) {
    history.pushState(data, "", url);
  }
}
